import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import {
  Col,
  Form,
  Row,
} from 'antd';
import PropTypes from 'prop-types';
import OnTraccrTextInput from '../../../common/inputs/OnTraccrTextInput';
import OnTraccrCheckbox from '../../../common/inputs/OnTraccrCheckbox';

export default function GanttScheduleEditScheduleTab(props) {
  const {
    scheduleId,
    selectedSchedule = {},
    setScheduleFormData,
    visible,
    schedules,
  } = props;

  const [selectedSchedules, setSelectedSchedules] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    if (selectedSchedule.id && visible) {
      const formData = {
        name: selectedSchedule.name,
        scheduleIds: selectedSchedule.schedules,
      };

      form.setFieldsValue(formData);
      setScheduleFormData(formData);
      setSelectedSchedules(selectedSchedule.schedules);
    } else {
      form.resetFields();
      setSelectedSchedules([]);
    }
  }, [selectedSchedule, visible]);

  const filteredSchedules = useMemo(() => {
    const relevantSchedules = [];

    schedules.forEach((s) => {
      if (s.id === scheduleId || !s.id) {
        return;
      }

      relevantSchedules.push({
        value: s.id,
        label: s.project ? s.project.name : s.name,
      });
    });

    return relevantSchedules.sort((a, b) => a.label.localeCompare(b.label));
  }, [schedules, scheduleId]);

  const onFormChange = (_, allValues) => {
    setScheduleFormData(allValues);
  };

  const selectedScheduleIdSet = useMemo(() => new Set(selectedSchedules), [selectedSchedules]);

  const onScheduleChange = useCallback((id) => (checked) => {
    const list = [...selectedSchedules];
    if (checked) {
      list.push(id);
    } else {
      const index = list.indexOf(id);
      if (index > -1) {
        list.splice(index, 1);
      }
    }

    setSelectedSchedules(list);
    setScheduleFormData({ ...form.getFieldsValue(), scheduleIds: list });
  }, [selectedSchedules, form, setScheduleFormData]);

  return (
    <Form
      form={form}
      onValuesChange={onFormChange}
      layout="vertical"
    >
      <Form.Item
        label="Name"
        name="name"
      >
        <OnTraccrTextInput disabled={selectedSchedule.isMaster} />
      </Form.Item>
      { !!selectedSchedule.isMaster && (
        <Form.Item
          label="Schedules"
          name="scheduleIds"
        >
          {filteredSchedules.map((schedule) => (
            <Row key={schedule.value}>
              <Col span={24}>
                <OnTraccrCheckbox
                  style={{ marginTop: 5 }}
                  value={selectedScheduleIdSet.has(schedule.value)}
                  label={schedule.label}
                  onChange={onScheduleChange(schedule.value)}
                />
              </Col>
            </Row>
          ))}
        </Form.Item>
      )}
    </Form>
  );
}

GanttScheduleEditScheduleTab.propTypes = {
  setScheduleFormData: PropTypes.func,
  visible: PropTypes.bool.isRequired,
  scheduleId: PropTypes.string.isRequired,
  schedules: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    isMaster: PropTypes.number,
  })).isRequired,
  selectedSchedule: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    schedules: PropTypes.arrayOf(PropTypes.string),
    isMaster: PropTypes.number,
  }),
};

GanttScheduleEditScheduleTab.defaultProps = {
  setScheduleFormData: () => {},
  selectedSchedule: {},
};
